<template>
    <Widget :widget_id="widget_id" :id="'WIDGET'+widget_id">
		<div class="widget-attrs"
            @scroll="onScroll"
        >
            <!-- IE 2026 10 18 / ODOO-347310: a record loaded from a source system (meta.source_*) — its image and the "open in source" link above the form -->
            <div class="source-strip" v-if="sourceUrl || sourceImageSrc">
                <!-- IE 2026 10 19 / ODOO-347310 (ревью ie-webscm7): место под изображение — по ссылке (sourceImageSrc); не загрузилось — значок, а не пустая полоса -->
                <span v-if="sourceImageSrc" class="source-strip-img" :title="t('Open the image')" @click="openSourceImage">
                    <img v-if="sourceImageUrl" :src="sourceImageUrl" alt="">
                    <i v-else class="pi pi-image"></i>
                </span>
                <a v-if="sourceUrl" class="source-strip-link" :href="sourceUrl" target="_blank" rel="noopener noreferrer" :title="sourceUrl">
                    <i class="pi pi-external-link"></i><span>{{ t('Open in {system}', { system: sourceSystemTitle }) }}</span>
                </a>
                <span v-if="sourceUrl" class="source-strip-host">{{ sourceHost }}</span>
            </div>
            <component v-for="attr in WIDGET.view"
                :widget_id="widget_id" 
                :key="attr.html_id"
                :is="attr.component"
                :attr_id="attr.id"
            />
        </div>
    </Widget>
</template>

<script>
import { useMainStore } from '@/stores/mainStore'
import { stalePageGuard_on, inDeactivatedTree } from '@/utils/stalePage'   // IE 2026 10 17 / ODOO-5800: деактивированная KeepAlive-страница виджетом не владеет (fe.ux.stalePageGuard)
import { toRaw } from 'vue'   // IE 2026 10 13 / ODOO-5800: признак фоновой рассылки — на сыром WIDGET
import { sourceUrlFromMeta, linkLabel } from '@/utils/sourceLink'   // IE 2026 10 18 / ODOO-347310
import { loadImage, openImage } from '@/utils/sourceImage'   // IE 2026 10 18 / ODOO-347310
import { pollKeepsRowForm_on, rowForm_closeOnContentChange } from '@/utils/rowFormGate'   // IE 2026 10 13 / ODOO-5800: фоновое обновление не закрывает формы строк (fe.ux.pollKeepsRowForm)

export default {
    props: [
        'widget_id',
    ],
    data: () => ({ 
        WIDGET: {},
        sourceImageUrl: '',   // IE 2026 10 18 / ODOO-347310: blob URL of meta.source_image_url
        sourceUrl: '',   // IE 2026 10 18 / ODOO-347310: "open in source" link of the open record (meta.source_*)
        sourceHost: '',
        sourceSystemTitle: '',
        sourceImageSrc: '',   // IE 2026 10 18 / ODOO-347310: meta.source_image_url of the open record
    }),
    watch: {
        sourceImageSrc(src) {   // IE 2026 10 18 / ODOO-347310
            this.sourceImageUrl = ''
            if (!src) return
            loadImage(this.store, src, 256).then(u => { if (this.sourceImageSrc === src) this.sourceImageUrl = u })
        },
        // IE 2026 10 19 / ODOO-347310 (ревью ie-webscm7, вместо опроса раз в секунду): правки meta через реактивный WIDGET; запись,
        // пришедшая в СЫРОЙ WIDGET (Object.assign ответа widget_open в mainStore), пинает source_sync сама — как parents_tree
        'WIDGET.record.meta': { handler() { this.source_sync() }, deep: true },
    },
    setup() {
        const store = useMainStore();
        return { store }
    },
    created() {
        // console.log('created')
        const WIDGET = this.WIDGET = this.store.findWidget(this.widget_id).WIDGET
        // тот же случай, что в AttrTab: при пересоздании стола виджета в сторе
        // ещё нет — регистрировать vueObj не на чем, дальше идти нельзя
        if (!WIDGET) return
        // IE 2026 10 17 / ODOO-5800 (utils/stalePage.js): WidgetAttrs из деактивированной KeepAlive-страницы (второй Page того же стола) виджетом не владеет —
        // executeStoreMethod(WIDGET.vueObj) должен попадать в экземпляр на экране
        if (!(stalePageGuard_on((k, d) => this.store.setting?.(k, d)) && inDeactivatedTree(this))) this.WIDGET.vueObj = this   // IE 2026 10 17 / ODOO-5800

        this.store.widget_checkLoading(this)

        const WORKSPACE = this.store.WORKSPACES[WIDGET.workspace]
        this.PAGE = WORKSPACE?.PAGES?.[WIDGET.page]
    },
    mounted() {
        this.source_sync()   // IE 2026 10 18 / ODOO-347310
    },
    methods:{
        // IE 2026 10 18 / ODOO-347310: meta.source_* of the open record → link and image above the form. Зовут: mounted, watch meta,
        // content_Changed и mainStore после Object.assign(WIDGET, answer.WIDGET) — запись приходит в сырой WIDGET без реактивного триггера
        source_sync() {
            const W = this.store.findWidget(this.widget_id)?.WIDGET || this.WIDGET
            const m = W?.record?.meta
            const meta = m && typeof m === 'object' ? m : null
            const url = sourceUrlFromMeta(meta)
            const img = typeof meta?.source_image_url === 'string' ? meta.source_image_url.trim() : ''
            if (url !== this.sourceUrl) {
                this.sourceUrl = url
                this.sourceHost = linkLabel(url)
                const sys = String(meta?.source_system || 'odoo')
                this.sourceSystemTitle = sys.charAt(0).toUpperCase() + sys.slice(1)
            }
            if (img !== this.sourceImageSrc) this.sourceImageSrc = img
        },
        load_data() {
        },
        get_flex(binding) {
            if (!binding) {
                binding='_doc.data'
            }
            if (!this.WIDGET.view) {
                return {}
            }
            let attr = this.store.get_field(this.WIDGET.view, binding)
            if (!attr || !this.WIDGET.attrs_vueObj[attr.id]) {
                return {}
            }
            return this.WIDGET.attrs_vueObj[attr.id].flex
        },
        get_vueObj(binding) {
            if (!binding) {
                binding='_doc.data'
            }
            if (!this.WIDGET.view) {
                return {}
            }
            // при дублях name (вложенные конфиг-гриды в колонках других гридов не монтируются)
            // приоритет — элемент, не обёрнутый в AttrGrid/AttrTabGrid
            let attr = this.get_field_notInGrid(this.WIDGET.view, binding)
                || this.store.get_field(this.WIDGET.view, binding)
            if (!attr) {
                // секции мульти-вертикальной таблицы печати: их attr эфемерный
                // (в view его нет, id=undefined — в attrs_vueObj не регистрируется),
                // команды меню секции резолвим через реестр координаторов:
                // по биндингу '_doc.printX[N].attrs' или имени 'printX_secN'
                let m = /^(.+)\[(\d+)\]\.attrs$/.exec(binding)
                if (m && this.WIDGET._mvtObjs?.[m[1]]) {
                    return this.WIDGET._mvtObjs[m[1]].sectionRefs?.[+m[2]] || null
                }
                m = /^(.+)_sec(\d+)$/.exec(binding)
                if (m) {
                    for (const mvt of Object.values(this.WIDGET._mvtObjs || {})) {
                        if (mvt?.attr && (mvt.attr.name || 'print') === m[1]) {
                            return mvt.sectionRefs?.[+m[2] - 1] || null
                        }
                    }
                }
                return this.WIDGET.attrs_vueObj?.[binding] ?? null
            }
            let attr_vueObj = this.WIDGET.attrs_vueObj[attr.id]
            if (!attr_vueObj) {
                // найденное определение не смонтировано — ищем смонтированный компонент с этим name в реестре
                for (const vueObj_ of Object.values(this.WIDGET.attrs_vueObj)) {
                    if (vueObj_?.attr?.name === binding) {
                        return vueObj_
                    }
                }
            }
            return attr_vueObj
        },
        get_field_notInGrid(attrs, value) {
            for (const key of ['name', 'binding']) {
                const found = this.get_field_notInGrid0(attrs, value, key)
                if (found) {
                    return found
                }
            }
            return null
        },
        get_field_notInGrid0(attrs, value, key) {
            for (const attr of attrs) {
                if (attr[key] === value && !(attr.attr_type === 'AttrButton' && key === 'binding')) {
                    return attr
                }
            }
            for (const attr of attrs) {
                if (attr.attrs && attr.attr_type !== 'AttrGrid' && attr.attr_type !== 'AttrTabGrid') {
                    const found = this.get_field_notInGrid0(attr.attrs, value, key)
                    if (found) {
                        return found
                    }
                }
            }
            return null
        },
        get_selectedRow(binding='_doc.data') {
            let attr_vueObj = this.get_vueObj(binding)
            if (!attr_vueObj) {
                return null
            }
            let flex = attr_vueObj.flex
            if (!flex) {
                return null
            }
            let attr = attr_vueObj.attr
            let rows = flex.selectedRows
            if (attr.attr_type === 'AttrPivotTool') {
                if (flex.selection.row >= 0 && flex.selection.col >= 0) {
                    let detail = flex.getDetail(flex.selection.row, flex.selection.col)
                    return {iroot:String(flex.selection.row), icol:flex.selection.col, dataItem:detail[0]}
                }
            } else if (flex.selectedItem) {
                // console.log(flex.selectedItem)
                const dataItem = flex.selectedItem
                const iroot = attr_vueObj.iroot?.(dataItem) || ''

                return {iroot, dataItem}
            } else if (rows && rows.length) {
                // console.log(rows[0].dataItem)
                let dataItem = rows[0].dataItem,
                iroot = ''
                if (dataItem && this.store.isinstance_dict(dataItem)) {
                    iroot = attr_vueObj.iroot(dataItem)   // IE 2026 09 16: поиск по тождеству, маркер $cutMarker (вырезанные строки) не трогаем

                    if (attr_vueObj.parentDataItem_iroot) {
                        iroot = String(attr_vueObj.parentDataItem_iroot) + '.' + attr_vueObj.attr.childItemsPath + '.' + iroot
                    }
                }

                return {iroot, dataItem}
                // return {iroot:'0', dataItem:rows[0].dataItem}
            }
            return null
        },
        get_selectedRanges(binding='_doc.data') {
            let attr_vueObj = this.get_vueObj(binding)
            if (!attr_vueObj) {
                return null
            }
            let flex = attr_vueObj.flex
            if (!flex) {
                return null
            }
            if (!flex.selectedRanges.length) {
                return null
            }
            return attr_vueObj.get_selectedRanges()
        },
        // Resolver delegates to the child grid (by binding), mirroring get_selectedRanges.
        // Needed because actionMenu items dispatch via WIDGET.vueObj (this component),
        // while get_feSelected / get_currentRow live on the AttrGrid component.
        get_feSelected(binding='_doc.data') {
            let attr_vueObj = this.get_vueObj(binding)
            if (!attr_vueObj || !attr_vueObj.get_feSelected) {
                return null
            }
            return attr_vueObj.get_feSelected()
        },
        get_currentRow(binding='_doc.data') {
            let attr_vueObj = this.get_vueObj(binding)
            if (!attr_vueObj || !attr_vueObj.get_currentRow) {
                return null
            }
            return attr_vueObj.get_currentRow()
        },
        get_currentGroup(binding='_doc.data') {   // IE 2026 11 03 / ODOO-349799 (group-records)
            let attr_vueObj = this.get_vueObj(binding)   // IE 2026 11 03 / ODOO-349799 (group-records)
            return attr_vueObj && attr_vueObj.get_currentGroup ? attr_vueObj.get_currentGroup() : null   // IE 2026 11 03 / ODOO-349799 (group-records)
        },
        get_selectedItems(binding='_doc.data') {
            let flex = this.get_flex(binding),
                rows = flex.selectedRows,
                items = []
            if (flex.selectedItem) {
                items.push(flex.selectedItem)
            } else if (rows && rows.length) {
                for (let row of rows)
                    if (row.dataItem && row.isVisible)
                        items.push(row.dataItem)
            }
            return items
        },
        content_Changed_attr_vueObj(binding, action) {
            let attr_vueObj = this.get_vueObj(binding)
            if (attr_vueObj && attr_vueObj.content_Changed) {
                attr_vueObj.content_Changed(action)
            }
        },
        content_Changed(attrs=null, command=null, filters=null, opts=null) {   // IE 2026 10 13 / ODOO-5800: opts.keepRowForms — фоновое обновление (опрос каскада / финиш прогона)
            this.source_sync()   // IE 2026 10 19 / ODOO-347310: запись могла смениться (importRecord / ответ команды) — полоса источника
            // html_id + '1' -- this will generate ne key for v-for
            let change_html_id = false
            let keepRowForms = false   // IE 2026 10 13 / ODOO-5800: рассылка фонового обновления (маркер) — гриды не перецепляют форму строки своей перестройкой
            if (attrs==null) {
                attrs = this.WIDGET.view
                if (rowForm_closeOnContentChange(opts, pollKeepsRowForm_on((k, d) => this.store?.setting?.(k, d))))   // IE 2026 10 13 / ODOO-5800: при opts.keepRowForms и флаге ВКЛ формы строк остаются открытыми
                    this.store.close_childrenWidgets(this.WIDGET, 'widget-row', 'widget-row-viewParams') // 2025-12-24
                else keepRowForms = true   // IE 2026 10 13 / ODOO-5800
            }
            // IE 2026 10 13 / ODOO-5800: признак на сыром WIDGET (без реактивности) только на время синхронной рассылки — AttrGrid.content_Changed запоминает его для своей перестройки
            const rawW = keepRowForms ? toRaw(this.WIDGET) : null
            if (rawW) rawW._rowFormKeepNow = true
            try {   // IE 2026 10 13 / ODOO-5800
            for (let attr of attrs || []) {
                if (attr.use !== false) {
                    if (!change_html_id) {
                        if (!filters || filters.includes(attr.attr_type)) {
                            let vueObj = this.WIDGET.attrs_vueObj[attr.id]
                            if (vueObj) {
                                // ?.() — зарегистрированный attr-компонент без
                                // content_Changed не должен ронять весь broadcast
                                vueObj.content_Changed?.(command)
                            }
                        }
                    } else {
                        if (attr.html_id) {
                            attr.html_id += '1'
                        }
                    }
                    if (attr.attrs) {
                        this.content_Changed(attr.attrs, command, filters)
                    }
                }
            }
            } finally { if (rawW) rawW._rowFormKeepNow = false }   // IE 2026 10 13 / ODOO-5800
        },
        openSourceImage() { openImage(this.store, this.sourceImageSrc) },   // IE 2026 10 18 / ODOO-347310
        onScroll(e) {
            this.PAGE.vueObj.refreshe_svg()
        },
    }
}
</script>

<style scoped>
.widget-attrs {
    height: 100%;
    width: 100%;
    overflow: auto;
}
/* IE 2026 10 18 / ODOO-347310: image and source link of a loaded record */
.source-strip {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 6px 10px;
    border-bottom: 1px solid #e2e8f0;
}
.source-strip-img {
    width: 96px;
    height: 96px;
    flex: none;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    background: #fff;
    cursor: zoom-in;
    color: #94a3b8;
}
.source-strip-img img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
}
.source-strip-img .pi-image {
    font-size: 2rem;
}
.source-strip-link {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 4px 10px;
    border: 1px solid #c7d2fe;
    border-radius: 6px;
    color: #4338ca;
    text-decoration: none;
    font-weight: 600;
}
.source-strip-link:hover { background: #eef2ff; }
.source-strip-host { color: #64748b; font-size: 0.85em; }
</style>